import useObservable from './useObservable';
import { FetchInlineHelpContentAPIResponse, inlineHelpContentStore$ } from '../store/inlineHelpContentStore';

function useInlineHelpContent() {
  const { response } = useObservable<FetchInlineHelpContentAPIResponse>(
    inlineHelpContentStore$
  );

  return {
    response
  };
}

export default useInlineHelpContent;